export default "__VITE_ASSET__DwUhtEtC__"